import { BIAS_TYPE_MESSAGE_IDS } from 'apps/sigma2-ui/src/constants/data';
import React from 'react';
import { BiasType } from 'libs/end-to-end/src/bias-type';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { MyFocusAreaDefinition } from 'libs/end-to-end/src/my-focus-area-definition';

export const TreatmentMetaDetails: React.FC<{
  levelDefinition: LevelDefinition;
  focusArea: MyFocusAreaDefinition;
  biasType: BiasType;
}> = (props) => {
  const language = useLanguage();
  const { levelDefinition, focusArea, biasType } = props;

  return (
    <div className="flex flex-row">
      <p className="text-xs font-normal font-sans leading-[18px]">
        {focusArea.displayName}
      </p>
      <p className="text-xs font-normal font-sans leading-[18px] px-[5px]">•</p>
      <p className="text-xs font-normal font-sans leading-[18px]">
        {levelDefinition.displayName}
      </p>
      <p className="text-xs font-normal font-sans leading-[18px] px-[5px]">•</p>
      <p className="text-xs font-normal font-sans leading-[18px]">
        {language[BIAS_TYPE_MESSAGE_IDS[biasType]]()}
      </p>
    </div>
  );
};
